module.exports = __webpack_public_path__ + "static/media/Promo Video Script_1633540446204.9fd3c557.docx";